import React from "react";

// const BULK_STATUSES = [
//   { status: "Rejected", label: "Reject", className: "reject" },
//   { status: "On Hold", label: "On Hold", className: "hold" },
//   { status: "Short Listed", label: "Shortlist", className: "shortlist" },
//   { status: "Hired", label: "Mark Hired", className: "hire" },
// ];

const BulkActionBar = ({ count, disabled, onAssignStage, onBulkStatus }) => (
  <div className="bulk-action-bar-v2">
    <span>{count} selected</span>
    <div className="bulk-actions">
      <button className="bulk-btn-v2" onClick={onAssignStage} disabled={disabled}>Assign Stage</button>
      {/* {BULK_STATUSES.map((b) => (
        <button key={b.status} className={`bulk-btn-v2 ${b.className}`} onClick={() => onBulkStatus(b.status)} disabled={disabled}>
          {b.label}
        </button>
      ))} */}
    </div>
  </div>
);

export default BulkActionBar;
